var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { ref, nextTick, onMounted, onUnmounted, watch } from "vue";
import { CircleXIcon } from "lucide-vue-next";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Dialog',
    props: {
        open: { type: Boolean, required: false, default: false },
        closeable: { type: Boolean, required: false, default: true },
        modal: { type: Boolean, required: false, default: true },
        closeOnBackdrop: { type: Boolean, required: false }
    },
    emits: ["close", "open", "update:open"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const emit = __emit;
        // Template refs
        const dialogRef = ref();
        // Internal state
        const isOpen = ref(false);
        const isModal = ref(props.modal);
        const resolvePromise = ref(null);
        // Watch for prop changes
        watch(() => props.open, (newValue) => {
            if (newValue && !isOpen.value) {
                openDialog();
            }
            else if (!newValue && isOpen.value) {
                closeDialog();
            }
        });
        // Methods
        const openDialog = () => __awaiter(this, void 0, void 0, function* () {
            if (!dialogRef.value || isOpen.value)
                return;
            yield nextTick();
            if (isModal.value) {
                dialogRef.value.showModal();
            }
            else {
                dialogRef.value.show();
            }
            isOpen.value = true;
            emit("open");
            emit("update:open", true);
        });
        const closeDialog = (result = { action: "close" }) => {
            if (!dialogRef.value || !isOpen.value)
                return;
            dialogRef.value.close();
            isOpen.value = false;
            emit("close", result);
            emit("update:open", false);
            // Resolve promise if exists
            if (resolvePromise.value) {
                resolvePromise.value(result);
                resolvePromise.value = null;
            }
        };
        // Public API methods
        const open = () => {
            return new Promise((resolve) => {
                resolvePromise.value = resolve;
                openDialog();
            });
        };
        const close = (result = { action: "close" }) => {
            closeDialog(result);
        };
        const accept = (data) => {
            closeDialog({ action: "accept", data });
        };
        const cancel = (data) => {
            closeDialog({ action: "cancel", data });
        };
        // Event handlers
        const handleClose = () => {
            if (isOpen.value) {
                closeDialog({ action: "close" });
            }
        };
        // Handle ESC key
        const handleKeydown = (event) => {
            if (event.key === "Escape" && isOpen.value && props.closeable) {
                event.preventDefault();
                close({ action: "close" });
            }
        };
        // Lifecycle
        onMounted(() => {
            document.addEventListener("keydown", handleKeydown);
            // Open if prop is true on mount
            if (props.open) {
                openDialog();
            }
        });
        onUnmounted(() => {
            document.removeEventListener("keydown", handleKeydown);
        });
        // Expose public API
        __expose({
            open,
            close,
            accept,
            cancel,
            isOpen,
        });
        const __returned__ = { props, emit, dialogRef, isOpen, isModal, resolvePromise, openDialog, closeDialog, open, close, accept, cancel, handleClose, handleKeydown, get CircleXIcon() { return CircleXIcon; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
